module.exports = __webpack_public_path__ + "img/partly-cloudy-night.e47c87c3.svg";